import { render, staticRenderFns } from "./SopSelect.vue?vue&type=template&id=fbf15e86"
import script from "./SopSelect.vue?vue&type=script&lang=js"
export * from "./SopSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports